import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider } from './contexts/SessionContext';
import { StartPageRedirect } from './components/StartPageRedirect';
import { PreviewToggles } from './components/PreviewToggles';
import { Home } from './pages/Home';
import { Dashboard } from './pages/Dashboard';
import { ChampionShirt } from './pages/ChampionShirt';
import { Login } from './pages/Login';
import { EmailPreview } from './pages/EmailPreview';
import { CHAMPION_SHIRT_PATH } from './data/site';
type AppProps = {
  startLoggedIn?: boolean;
  championEligible?: boolean;
  hasIncompleteRegistration?: boolean;
  startPage?: 'home' | 'dashboard' | 'productPage' | 'email';
};
const startPaths = {
  home: '/',
  dashboard: '/dashboard',
  productPage: CHAMPION_SHIRT_PATH,
  email: '/email'
};
export function App({
  startLoggedIn = true,
  championEligible = true,
  hasIncompleteRegistration = true,
  startPage = 'home'
}: AppProps) {
  return <SessionProvider startLoggedIn={startLoggedIn} championEligible={championEligible} hasIncompleteRegistration={hasIncompleteRegistration} data-id="element-0" data-mp="3ikh5c1uvgeva">
      <BrowserRouter data-id="element-1" data-mp="3mj6k9yvk64h1">
        <StartPageRedirect to={startPaths[startPage]} data-id="element-2" data-mp="3rcj2nr9n9f1c" />
        <PreviewToggles data-id="element-3" data-mp="3rd191gq0t9mz" />
        <Routes data-id="element-4" data-mp="5yj0slx59ec">
          <Route path="/" element={<Home data-id="element-6" data-mp="4ww9qvjiygs" />} data-id="element-5" data-mp="6hrlipoilfp" />
          <Route path="/dashboard" element={<Dashboard data-id="element-8" data-mp="2zl3bdjx5744s" />} data-id="element-7" data-mp="56nfhsbnbo2" />
          <Route path={CHAMPION_SHIRT_PATH} element={<ChampionShirt data-id="element-10" data-mp="2zmwggus3xgao" />} data-id="element-9" data-mp="2zlv7cvunj3vl" />
          <Route path="/login" element={<Login data-id="element-12" data-mp="33lx0ggmbmoz9" />} data-id="element-11" data-mp="33mowfsjtyoq2" />
          <Route path="/email" element={<EmailPreview data-id="element-14" data-mp="33oi3h8ycvayl" />} data-id="element-13" data-mp="33n6zb810016y" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-16" data-mp="38kqau06b9zv7" />} data-id="element-15" data-mp="38l8iru2c62iy" />
        </Routes>
      </BrowserRouter>
    </SessionProvider>;
}